module.exports = __webpack_public_path__ + "static/media/test16_4.89057215.png";